module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "m-header"
  }, [_c('div', {
    staticClass: "m-header-bg",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "m-header-title fz15"
  }, [_vm._v(_vm._s(_vm.title))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-aa957936"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 215
// module chunks = 1